/* global window.ParamsDataPopin */

import * as Utils from './components/utils.js';

export default formLoginRecruteurs => {
    console.log('formLoginRecruteurs');
    const dataAction = formLoginRecruteurs.getAttribute('data-action');
    const requiredFields = formLoginRecruteurs.querySelectorAll('[required]');
    const inputEmail = formLoginRecruteurs.querySelector('#form-login-recruteurs-email');
    const inputPassword = formLoginRecruteurs.querySelector('#form-login-recruteurs-password');
    const inputSubmit = formLoginRecruteurs.querySelector('#form-login-recruteurs-submit');
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let init = true;
    let validity = true;

    function addErrorMessage(field) {
        const msg = field.closest('.fr-input-group').querySelector(`#${field.getAttribute('aria-describedby').split(' ')[0]}`);
        const html = `${field.dataset.message}`;

        msg.innerHTML = html;

        msg.classList.remove('hide');

        field.addEventListener('change', formFieldsValidate);
    }

    function formFieldsValidate() {
        if (init === true) return;

        validity = true;

        for (const field of requiredFields) {
            if (!field.checkValidity()) {
                field.closest('.fr-input-group').classList.add('error');
                field.setAttribute('aria-invalid', true);
                validity = false;

                addErrorMessage(field);
            } else {
                if (field.id === 'form-login-recruteurs-email') {
                    if (!field.value.match(emailRegex)) {
                        field.closest('.fr-input-group').classList.add('error');
                        field.setAttribute('aria-invalid', true);
                        validity = false;

                        addErrorMessage(field);
                    } else {
                        field.closest('.fr-input-group').classList.remove('error');
                        field.setAttribute('aria-invalid', false);
                    }
                } else {
                    field.closest('.fr-input-group').classList.remove('error');
                    field.setAttribute('aria-invalid', false);
                }

                if (field.closest('.fr-input-group').querySelector('.message.error')) {
                    field.closest('.fr-input-group').querySelector('.message.error').innerHTML = '';
                }
            }
        }

        return validity;
    }

    function sendAjax() {
        const ajaxData = new FormData();
        const request = new XMLHttpRequest();
        const url = window.ParamsDataPopin.wp_ajax_url;

        ajaxData.append('action', dataAction);
        ajaxData.append('nonce', window.ParamsDataPopin.nonce);
        ajaxData.append('user_login', inputEmail.value);
        ajaxData.append('user_password', inputPassword.value);

        request.open('POST', url, true);
        request.send(ajaxData);

        request.onload = () => {
            let response = request.response;

            if (typeof response === 'string') {
                response = JSON.parse(response);
            }
            
            switch (response.status) {
                case 200:

                    console.log(response.url);

                    switch (document.querySelector('#modal-login-recruteurs').dataset.from) {
                        case 'saveSearchBtn':
                        case 'singleOffer':
                        case 'favBtnHome':
                        case 'favBtnSingleOffer':
                            window.location.reload();
                            break;
                        default:
                            Utils.closeDsfrModal('modal-login-recruteurs');

                            if (!response.blank) {
                                window.location.href = response.url;
                            } else {
                                // window.open(response.url, '_blank');
                                window.location.href = response.url;
                                // window.location.reload();
                            }
                            
                            break;
                    }
                    break;
                // case 201:
                //     // jQuery('.popin.login').marypopin('close');
                //     Utils.closeDsfrModal('modal-login-recruteurs');

                //     setTimeout(() => {
                //         // jQuery('.popin.migration').marypopin('open');
                //         Utils.openDsfrModal('modal-migration');
                //     }, 500);
                //     break;
                case 202:
                case 500:
                    formLoginRecruteurs.classList.remove('loading-please-wait');

                    // jQuery('.popin.login').marypopin('close');
                    Utils.closeDsfrModal('modal-login-recruteurs');

                    Utils.banner(
                        'error',
                        response.message.title,
                        response.message.subtitle,
                        '#modal-recruteurs-opener'
                    );

                    break;
                default:
                    break;
            }
        };
    }

    function checkLogin() {
        init = false;

        if (!formFieldsValidate()) {
            formLoginRecruteurs.querySelector('.form-input-container.error').scrollIntoView();
            document.querySelector('[aria-invalid="true').focus();
        } else {
            formLoginRecruteurs.classList.add('loading-please-wait');
            document.body.setAttribute('data-focus', 'account-menu-btn-not-connected');
            sendAjax();
        }
    }

    inputSubmit.addEventListener('click', event => {
        event.preventDefault();
        checkLogin();
    });
};
